import { computed } from 'vue'
import { isActive } from '@/services/feature-flag-service'

/**
 * If the mobile testbed split is active or not
 */
export const isMobileTestbedActive = () => {
  return !!isActive('prototype_fox_mobile_testbed')
}

/**
 * Returns the value of mobile testbed split
 */
export const getMobileTestbedSplitValue = () => {
  return isActive('prototype_fox_mobile_testbed')
}

/**
 * Determines if the mobile testbed split value is for a long press action or not
 */
export const isLongPressActionActive = () => {
  const splitValue = getMobileTestbedSplitValue()
  return splitValue && typeof splitValue === 'string'
    ? ['long_press_waypoint', 'long_press_menu'].includes(splitValue)
    : false
}

export const isMapPinsEnabled = computed(() =>
  isActive('prototype_fox_waypoint_pins')
)

export const isExploreEnabled = computed(() =>
  isActive('prototype_fox_explore')
)

export const isMapMarkupBulkSelectEnabled = computed(() =>
  isActive('prototype_fox_map_markup_bulk_select')
)
